import {Button} from '@mui/material';
import AppStore from 'assets/images/svg/apple-store.svg';
import AppStoreEN from 'assets/images/Button/appStore-ENG.png';
import AppStoreESP from 'assets/images/Button/appStore-ESP.png';
import AppStoreHIN from 'assets/images/Button/appStore-HIN.png';
import AppStoreKOR from 'assets/images/Button/appStore-KOR.png';
import AppStoreJAP from 'assets/images/Button/appStore-JAP.png';
import {makeStyles} from '@material-ui/core/styles';
import {DownloadButton} from './DownloadButton';
import {useTranslation} from 'react-i18next';
import {LANGUAGE_I18N, link_apple_download} from 'common/constants';
import {useEffect, useState} from 'react';

const AppStoreButton = ({...props}) => {
  const useStyles = makeStyles((theme) => ({
    image: {
      height: 60,
      [theme.breakpoints.down('sm')]: {
        height: 40,
      },
      [theme.breakpoints.down('xs')]: {
        height: 60,
      },
    },
  }));
  const classes = useStyles();
  const {t} = useTranslation();
  const [image, setImage] = useState();
  const {i18n} = useTranslation();
  useEffect(() => {
    if (i18n.language == LANGUAGE_I18N.ENG) {
      setImage(AppStoreEN);
    }
    if (i18n.language == LANGUAGE_I18N.ESP) {
      setImage(AppStoreESP);
    }
    if (i18n.language == LANGUAGE_I18N.JAP) {
      setImage(AppStoreJAP);
    }
    if (i18n.language == LANGUAGE_I18N.HIN) {
      setImage(AppStoreHIN);
    }
    if (i18n.language == LANGUAGE_I18N.KOR) {
      setImage(AppStoreKOR);
    }
  }, [i18n.language]);
  return (
    <Button onClick={() => window.open(link_apple_download)}>
      <img src={image} style={{height: 60}} />
    </Button>
  );
};

export {AppStoreButton};
